import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.css";
import Footer from "../../components/Footer/Footer";

const SERVICE_ID = "service_rnqp5dd";
const TEMPLATE_ID = "template_8pwdakc"; // ← your actual EmailJS template id
const PUBLIC_KEY = "QKlnswpeeF5706uvk";

export default function Contact() {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState({ type: "", msg: "" });

  const sendEmail = (e) => {
    e.preventDefault();
    if (!formRef.current) return;

    setSending(true);
    setStatus({ type: "", msg: "" });

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(() => {
        setStatus({
          type: "ok",
          msg: "Thanks! Your message was sent. I’ll get back to you soon.",
        });
        formRef.current.reset();
      })
      .catch(() => {
        setStatus({
          type: "err",
          msg: "Something went wrong. Please try again in a moment.",
        });
      })
      .finally(() => setSending(false));
  };

  return (
    <>
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <h1 className="contact-title">Get in Touch</h1>
          <p className="contact-sub">
            Questions about lessons or audio support? Send a message and I’ll
            follow up with next steps.
          </p>

          <div className="contact-grid">
            {/* Left — info (unchanged) */}
            <div className="contact-info">
              <h2>Contact Information</h2>
              <ul>
                <li>
                  <strong>Email:</strong>{" "}
                  <a href="mailto:ivan@melodiamusicllc.com">
                    ivan@melodiamusicllc.com
                  </a>
                </li>
                <li>
                  <strong>Instagram:</strong>{" "}
                  <a
                    href="https://www.instagram.com/ivanology_/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @ivanology_
                  </a>
                </li>
                <li>
                  <strong>Facebook:</strong>{" "}
                  <a
                    href="https://www.facebook.com/ivan.simangas/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    facebook.com/ivan.simangas
                  </a>
                </li>
                <li>
                  <strong>TikTok:</strong>{" "}
                  <a
                    href="https://www.tiktok.com/@ivanology_?_t=8nm8z69ZLFn&_r=1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @ivanology_
                  </a>
                </li>
              </ul>
            </div>

            {/* Right — form */}
            <form ref={formRef} onSubmit={sendEmail} className="contact-form">
              <h2>Send a Message</h2>

              <div className="form-group">
                <label htmlFor="name">Name</label>
                {/* must be name="name" to match EmailJS template */}
                <input id="name" name="name" type="text" required />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                {/* must be name="email" to match EmailJS template */}
                <input id="email" name="email" type="email" required />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                {/* must be name="phone" to match EmailJS template */}
                <input id="phone" name="phone" type="tel" required />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                {/* must be name="message" to match EmailJS template */}
                <textarea id="message" name="message" rows="5" required />
              </div>

              <button type="submit" className="btn-primary" disabled={sending}>
                {sending ? "Sending..." : "Send Message"}
              </button>

              {status.msg && (
                <p
                  className="status"
                  style={{
                    marginTop: "10px",
                    color: status.type === "ok" ? "#9be28f" : "#ff7b7b",
                    fontWeight: 500,
                  }}
                >
                  {status.msg}
                </p>
              )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
